// src/pages/ChatboardPage.js
import React from 'react';
import Chatboard from '../components/Chatboard/Chatboard';
import './ChatboardPage.css';

const ChatboardPage = ({ user, userProfile }) => {
  return (
    <div className="chatboard-page">
      <Chatboard user={user} userProfile={userProfile} />
    </div>
  );
};

export default ChatboardPage;